(() => {
  "use strict";
  var e,
    t = {
      207: () => {
        const e = {
          animateOverlay: function () {
            var e = document.getElementById("entry"),
              t = document.getElementById("entry-overlay");
            gsap
              .timeline({
                scrollTrigger: {
                  trigger: e,
                  scrub: !0,
                  start: "top top",
                  end: "bottom top",
                  pinSpacing: !0,
                  pin: e,
                },
              })
              .to(t, { height: 0, ease: "none" });
          },
          animateLine: function () {
            var e = document.getElementById("overlay-content-container"),
              t = document.getElementById("overlay-line");
            gsap
              .timeline({
                scrollTrigger: {
                  trigger: e,
                  start: "99% 98%",
                  end: "100% 98%",
                  scrub: !0,
                },
              })
              .to(t, { opacity: 0 });
          },
          animateText: function () {
            var e = document.getElementById("overlay-content-container"),
              t = document.getElementById("overlay-caption"),
              n = gsap.timeline({
                scrollTrigger: {
                  trigger: e,
                  start: "bottom bottom",
                  end: "140% bottom",
                  scrub: !0,
                },
              }),
              i = -500;
            window.innerHeight < 920 && (i = -200),
              n.to(t, { y: i, opacity: 0 });
          },
        };
        const t = {
          animateText: function () {
            var e = document.getElementById("entry-content-container"),
              t = document.getElementById("entry-caption");
            gsap
              .timeline({
                scrollTrigger: {
                  trigger: e,
                  start: "130% 80%",
                  end: "160% 80%",
                  scrub: !0,
                },
              })
              .to(t, { y: -20, opacity: 1 });
          },
        };
        function n(e) {
          e.classList.add("text-green"),
            e.classList.remove("text-white"),
            e.classList.remove("text-purple"),
            e.classList.remove("text-yellow");
        }
        function i(e) {
          e.classList.add("text-white"),
            e.classList.remove("text-blue"),
            e.classList.remove("text-purple"),
            e.classList.remove("text-yellow");
        }
        function o(e, t, n) {
          var i = t.getAttribute("href"),
            o = null == i ? void 0 : i.slice(1),
            r = e.classList.contains(o);
          r &&
            (n ? t.classList.add("text-yellow") : t.classList.add("text-purple"),
            t.classList.remove("text-green"),
            t.classList.remove("text-white"));
        }
        function r() {
          var e = document.getElementById("entry").offsetHeight;
          window.scrollTo({ top: e, behavior: "smooth" });
        }
        const a = {
          animateColor: function () {
            if (!(window.innerWidth < 800)) {
              var e = Array.from(
                document.getElementsByClassName("plot-section")
              );
              Array.from(document.getElementsByClassName("menu-item")).map(
                function (t) {
                  var r = t.getBoundingClientRect().top + 16;
                  ScrollTrigger.create({
                    trigger: e[0],
                    start: "bottom ".concat(r, "px"),
                    end: "bottom ".concat(r, "px"),
                    onEnter: function () {
                      i(t);
                    },
                    onEnterBack: function (e) {
                      i(t),
                        (function (e) {
                          e.classList.remove(
                            "text-green,text-yellow,text-purple"
                          ),
                            e.classList.add("text-white");
                        })(t);
                    },
                    onLeave: function () {
                      n(t), o(e[1], t);
                    },
                  }),
                    ScrollTrigger.create({
                      trigger: e[1],
                      start: "bottom ".concat(r, "px"),
                      end: "bottom ".concat(r, "px"),
                      onEnterBack: function (n) {
                        o(e[1], t);
                      },
                    }),
                    e.slice(2).map(function (e) {
                      ScrollTrigger.create({
                        trigger: e,
                        start: "top ".concat(r, "px"),
                        end: "top ".concat(r, "px"),
                        onEnter: function (e) {
                          return (function (e, t) {
                            var r = e.trigger,
                              a = r.classList.contains("data-background-dark");
                            a ? i(t) : n(t), o(r, t, a);
                          })(e, t);
                        },
                        onEnterBack: function (e) {
                          return (function (e, t) {
                            var r,
                              a = (r =
                                null === e.trigger.previousElementSibling
                                  ? e.trigger.parentElement
                                      .previousElementSibling
                                  : e.trigger.previousElementSibling.classList.contains(
                                      "pin-spacer"
                                    )
                                  ? e.trigger.previousElementSibling.firstChild
                                  : e.trigger
                                      .previousElementSibling).classList.contains("data-background-dark");
                            a ? i(t) : n(t), o(r, t, a);
                          })(e, t);
                        },
                      });
                    });
                }
              );
            }
          },
          animateMenuArrow: function () {
            if (!(window.innerWidth < 800)) {
              var e = document.getElementById("menu-arrow"),
                t = document.getElementById("entry-overlay");
              gsap
                .timeline({
                  scrollTrigger: {
                    trigger: t,
                    start: "top top",
                    end: "90% center",
                    scrub: !0,
                  },
                })
                .to(e, { y: -500, opacity: 0 });
            }
          },
          animateOverlayOnWhoWeAreClick: function () {
            (window.innerWidth < 800
              ? document.getElementById("who-we-are-mobile")
              : document.getElementById("who-we-are")
            ).addEventListener("click", r);
          },
        };
        
        function m(e, t, n) {
          n
            ? (e.classList.remove("md:hidden"),
              t.classList.remove("md:block"),
              e.classList.add("md:block"),
              t.classList.add("md:hidden"))
            : (e.classList.remove("hidden"),
              t.classList.remove("block"),
              e.classList.add("block"),
              t.classList.add("hidden"));
        }
        function g(e, t, n) {
          n
            ? (e.classList.remove("md:block"),
              t.classList.remove("md:hidden"),
              e.classList.add("md:hidden"),
              t.classList.add("md:block"))
            : (e.classList.remove("block"),
              t.classList.remove("hidden"),
              e.classList.add("hidden"),
              t.classList.add("block"));
        }
        var u = function (e, t, n) {
          var i = Array.from(document.getElementsByClassName("plot-section")),
            o = t.getBoundingClientRect().top + 16;
          ScrollTrigger.create({
            trigger: i[0],
            start: "bottom ".concat(o, "px"),
            end: "bottom ".concat(o, "px"),
            onEnter: function () {
              return g(e, t, n);
            },
            onEnterBack: function () {
              return g(e, t, n);
            },
            onLeave: function () {
              return m(e, t, n);
            },
          }),
            i.slice(2).map(function (i) {
              ScrollTrigger.create({
                trigger: i,
                start: "top ".concat(o, "px"),
                end: "top ".concat(o, "px"),
                onEnter: function (i) {
                  return (function (e, t, n, i) {
                    e.trigger.classList.contains("data-background-dark")
                      ? g(t, n, i)
                      : m(t, n, i);
                  })(i, e, t, n);
                },
                onEnterBack: function (i) {
                  return (function (e, t, n, i) {
                    true ==
                    (null === e.trigger.previousElementSibling
                      ? e.trigger.parentElement.previousElementSibling
                      : e.trigger.previousElementSibling
                    ).classList.contains("data-background-dark")
                      ? g(t, n, i)
                      : m(t, n, i);
                  })(i, e, t, n);
                },
              });
            });
        };
        const p = {
          animateLogo: function () {
            if (!(window.innerWidth < 768)) {
              var e = document.getElementById("logo-dark"),
                t = document.getElementById("logo-light");
              u(e, t, !0);
            }
          },
          animateLogoMobile: function () {
            if (!(window.innerWidth > 800)) {
              var e = document.getElementById("logo-mobile-light"),
                t = document.getElementById("logo-mobile-dark");
              u(t, e, !1);
            }
          },
          animateHamburger: function () {
            if (!(window.innerWidth > 800)) {
              var e = document.querySelector(".hamburger-mobile-light"),
                t = document.querySelector(".hamburger-mobile-dark");
              u(t, e, !1);
            }
          },
        };
        var y = document.querySelector(".button-prev-mobile"),
          v = document.querySelector(".button-next-mobile"),
          h = document.querySelector(".button-prev"),
          f = document.querySelector(".button-next"),
          b = 1,
          w = 1,
          E = !1;
        function L(e) {
          var t,
            n = document.getElementsByClassName("testimonial-image");
          for (
            e > n.length && (b = 1), e < 1 && (b = n.length), t = 0;
            t < n.length;
            t++
          )
            n[t].style.display = "none";
          n[b - 1].style.display = "block";
        }
        function x(e) {
          var t = document.getElementsByClassName("testimonial-text");
          e > t.length && (w = 1), e < 1 && (w = t.length);
          for (var n = 0; n < t.length; n++)
            gsap.to(t[n], { opacity: 0, y: 40, duration: 0.3 });
          gsap.to(t[w - 1], {
            opacity: 1,
            y: 0,
            delay: 0.2,
            onComplete: function () {
              (E = !1), (f.disabled = !1), (h.disabled = !1);
            },
          });
          var i = w + " / " + t.length;
          window.innerWidth < 800
            ? (document.getElementsByClassName(
                "swiper-pagination-mobile"
              )[0].innerText = i)
            : (document.getElementsByClassName(
                "swiper-pagination"
              )[0].innerText = i);
        }
        function k() {
          (f.disabled = !0), (h.disabled = !0);
        }
        function B() {
          E || ((E = !0), k(), L((b += 1)), x((w += 1)));
        }
        function I() {
          E || ((E = !0), k(), L((b -= 1)), x((w -= 1)));
        }
        const T = function () {
          window.innerWidth < 800
            ? (y.addEventListener("click", I), v.addEventListener("click", B))
            : (h.addEventListener("click", I), f.addEventListener("click", B));
        };
        (window.onbeforeunload = function () {
          window.scrollTo(0, 0);
        }),
          gsap.registerPlugin(ScrollTrigger);
        var S,
          A,
          C,
          W,
          O,
          q,
          M = document.getElementById("graphic-video-mobile-ios"),
          N = document.getElementById("graphic-video"),
          P = Array.from(document.querySelectorAll(".autoplay"));
        window.addEventListener("load", function () {
          P.map(function (e) {
            e.play();
          }),
            (window.lenis = new Lenis()),
            lenis.on("scroll", function (e) {}),
            requestAnimationFrame(function e(t) {
              lenis.raf(t), requestAnimationFrame(e);
            });
        }),
          e.animateOverlay(),
          e.animateText(),
          e.animateLine(),
          t.animateText(),
          a.animateColor(),
          a.animateMenuArrow(),
          a.animateOverlayOnWhoWeAreClick(),
          p.animateLogo(),
          p.animateLogoMobile(),
          p.animateHamburger(),
          (S = document.getElementById("sidebar")),
          (A = document.getElementById("toggleSidebarMobile")),
          (C = document.getElementById("toggleSidebarMobile-dark")),
          (W = document.getElementById("closeSidebarMobile")),
          C.addEventListener("click", function () {
            return S.classList.toggle("hidden");
          }),
          A.addEventListener("click", function () {
            return S.classList.toggle("hidden");
          }),
          W.addEventListener("click", function () {
            return S.classList.toggle("hidden");
          }),
          Array.from(document.getElementsByClassName("mobile-menu-item")).map(
            function (e) {
              e.addEventListener("click", function () {
                S.classList.toggle("hidden");
              });
            }
          ),
          T(),
          (O = Array.from(document.querySelectorAll("[data-system='ios']"))),
          (q = Array.from(
            document.querySelectorAll("[data-system='android']")
          )),
          navigator.userAgent.match(/iPhone|iPad|Macintosh/i)
            ? q.map(function (e) {
                e.remove();
              })
            : O.map(function (e) {
                e.remove();
              });
      },
      120: () => {},
    },
    n = {};
  function i(e) {
    var o = n[e];
    if (void 0 !== o) return o.exports;
    var r = (n[e] = { exports: {} });
    return t[e](r, r.exports, i), r.exports;
  }
  (i.m = t),
    (e = []),
    (i.O = (t, n, o, r) => {
      if (!n) {
        var a = 1 / 0;
        for (d = 0; d < e.length; d++) {
          for (var [n, o, r] = e[d], c = !0, l = 0; l < n.length; l++)
            (!1 & r || a >= r) && Object.keys(i.O).every((e) => i.O[e](n[l]))
              ? n.splice(l--, 1)
              : ((c = !1), r < a && (a = r));
          if (c) {
            e.splice(d--, 1);
            var s = o();
            void 0 !== s && (t = s);
          }
        }
        return t;
      }
      r = r || 0;
      for (var d = e.length; d > 0 && e[d - 1][2] > r; d--) e[d] = e[d - 1];
      e[d] = [n, o, r];
    }),
    (i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (() => {
      var e = { 847: 0, 252: 0 };
      i.O.j = (t) => 0 === e[t];
      var t = (t, n) => {
          var o,
            r,
            [a, c, l] = n,
            s = 0;
          if (a.some((t) => 0 !== e[t])) {
            for (o in c) i.o(c, o) && (i.m[o] = c[o]);
            if (l) var d = l(i);
          }
          for (t && t(n); s < a.length; s++)
            (r = a[s]), i.o(e, r) && e[r] && e[r][0](), (e[r] = 0);
          return i.O(d);
        },
        n = (self.webpackChunkthe_plot_fe = self.webpackChunkthe_plot_fe || []);
      n.forEach(t.bind(null, 0)), (n.push = t.bind(null, n.push.bind(n)));
    })(),
    i.O(void 0, [252], () => i(207));
  var o = i.O(void 0, [252], () => i(120));
  o = i.O(o);
})();
